import { ScriptsArchived } from '@Containers/Scripts';

const ScriptsArchivedPage: React.FunctionComponent = () => <ScriptsArchived />;

export default ScriptsArchivedPage;
